import React, { useEffect, useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import Icon3 from '../../assest/images/Icon3.png';
import Icon9 from '../../assest/images/Icon9.png';
import CustomDropdown from '../common/CustomDropdown';
import x from '../../assest/images/x.png';
import config from "../../envconfig";
import { UserContext } from '../common/UserContext';
import Image from '../common/image';

function GMList() {
    const [listData, setListData] = useState([]);
    const [submenuOptions, setSubmenuOptions] = useState([]);
    const [showSubmenuModal, setShowSubmenuModal] = useState(false);
    const [firstFilter, setFirstFilter] = useState('');
    const [firstFilterSearch, setFirstFilterSearch] = useState('');
    const [secondFilter, setSecondFilter] = useState('');
    const [secondFilterSearch, setSecondFilterSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [statusFilter, setStatusFilter] = useState('');
    const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId, UM_UserType } = useContext(UserContext);
    const [firstFilterOptions, setFirstFilterOptions] = useState([]);
    const [secondFilterOptions, setSecondFilterOptions] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [machineTypes, setMachineTypes] = useState([]);
    const [selectedRights, setSelectedRights] = useState(null);
    const [selectedMachineName, setSelectedMachineName] = useState('');

    useEffect(() => {
        // Define the EXACT order as per table columns (from left to right)
        const columnOrder = [];

        // 1. Company Name - only for Super Admin (UM_UserType === 0)
        if (parseInt(UM_UserType) === 0) {
            columnOrder.push({ value: 'CM_CompanyName', label: 'Company Name', disabled: false });
        }

        // 2. Group Name - always shown
        columnOrder.push({ value: 'GRPM_GroupName', label: 'Group Name', disabled: false });

        // 3. Group Type - shown for Super Admin & Admin (0 or 1)
        if (parseInt(UM_UserType) === 0 || parseInt(UM_UserType) === 1) {
            columnOrder.push({ value: 'GroupType', label: 'Group Type', disabled: false });
        }

        // 4. Policy Name - always shown
        columnOrder.push({ value: 'CITPM_PolicyName', label: 'Policy Name', disabled: false });

        // 5. SCP Name - shown for Super Admin & Admin (not for regular users i.e. type 2)
        if (parseInt(UM_UserType) === 0 || parseInt(UM_UserType) === 1) {
            columnOrder.push({ value: 'SCPM_Name', label: 'SCP Name', disabled: false });
        }

        // Set both dropdowns to follow this exact visual order
        setFirstFilterOptions(columnOrder);
        setSecondFilterOptions(columnOrder.map(opt => ({ ...opt }))); // deep copy
    }, [UM_UserType]); // Only recompute when user type changes

    useEffect(() => {
        fetchListData();
    }, []);

    useEffect(() => {
        setCurrentPage(1);
    }, [firstFilterSearch, secondFilterSearch, statusFilter]);


    useEffect(() => {
        sessionStorage.setItem('UM_GroupId', UM_GroupId);
        sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
        sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
        sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
        sessionStorage.setItem('UM_UserId', UM_UserId);
        sessionStorage.setItem('UM_UserCode', UM_UserCode);
        sessionStorage.setItem('selectedScpId', selectedScpId);
        sessionStorage.setItem('UM_UserType', UM_UserType);
    }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId, UM_UserType]);

    const shouldShowSCPColumn = () => {
        const userType = parseInt(UM_UserType, 10);
        return userType === 0 || userType === 1;
    };


    const logAction = async (action, isError = false) => {
        console.log(`${isError ? '[ERROR] ' : ''}${action}`);
        try {
            const response = await fetch(`${config.API_URL}/api/log`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ module: "GroupMaster:", action, userCode: UM_UserCode, isError }),
            });

            if (!response.ok) {
                throw new Error('Failed to log action');
            }
        } catch (error) {
            console.error('Error logging action:', error);
        }
    };

    const fetchListData = () => {
        logAction("fetchListData(): started");
        fetch(`${config.API_URL}/groupmasterlist/${UM_UserType}/${UM_CompanyID}/${selectedScpId}`)
            .then(response => response.json())
            .then(data => {
                if (data && data.data) {
                    console.log(data);
                    setListData(data.data);
                    logAction("fetchListData(): Group List page accessed successfully");
                } else {
                    logAction("fetchListData(): Failed to fetch group list page", true);
                    console.error('Error fetching list data:', data.error);
                }
            })
            .catch(error => {
                logAction("fetchListData(): Error showing group list page", true);
                console.error('Error fetching list data:', error);
            });
        logAction("fetchListData(): ended");
    };

    const fetchGroupRights = async (groupId) => {
        try {
            const res = await fetch(`${config.API_URL}/groupRights/${groupId}`);
            const data = await res.json();

            if (data.success) {
                let machines = [];

                // Keep only entries with valid gri_AppID
                data.data.forEach(machine => {
                    if (machine.gri_AppID) {
                        machines.push(machine);
                    }

                    // If roleMenus exist, push as virtual machine
                    if (machine.roleMenus && machine.roleMenus.length > 0) {
                        machines.push({
                            gri_AppID: 1, // unique ID (make sure it won’t clash with real ones)
                            AppName: "SmartTrackerPlus",
                            rights: machine.roleMenus.map(menu => ({
                                STM_ID: menu.submenuId,
                                STM_RoleName: menu.submenuName,
                            }))
                        });
                    }
                });

                setMachineTypes(machines);
                setShowModal(true);
            }
        } catch (err) {
            console.error("Error fetching group rights", err);
        }
    };


    const fetchSubmenuOptions = (appId) => {
        const machine = machineTypes.find(m => m.gri_AppID === appId);
        if (machine) {
            setSubmenuOptions(machine.rights);
            setSelectedMachineName(machine.AppName); // store machine name
            setShowModal(false);
            setShowSubmenuModal(true);
        }
    };



    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedRights(null);
    };

    const handleFirstFilterChange = (event) => {
        const value = event.target.value;
        setFirstFilter(value);
        setFirstFilterSearch('');
        logAction("handleFirstFilterChange(): A column selected in the first filter");

        // Disable the selected value in second dropdown
        const updatedSecondOptions = secondFilterOptions.map(option => ({
            ...option,
            disabled: option.value === value
        }));
        setSecondFilterOptions(updatedSecondOptions);
    };

    const handleSecondFilterChange = (event) => {
        const value = event.target.value;
        setSecondFilter(value);
        setSecondFilterSearch('');
        logAction("handleSecondFilterChange(): A column selected in the second filter");

        // Disable the selected value in first dropdown
        const updatedFirstOptions = firstFilterOptions.map(option => ({
            ...option,
            disabled: option.value === value
        }));
        setFirstFilterOptions(updatedFirstOptions);
    };

    const handleStatusFilterChange = (event) => {
        const value = event.target.value;
        logAction("handleStatusFilterChange(): Status is changed in the dropdown");
        setStatusFilter(value);
        logAction("handleStatusFilterChange(): Data filtered according to the selected status");
    };
    const filteredListData = listData.filter(item => {
        const firstFilterValue = item[firstFilter];
        const secondFilterValue = item[secondFilter];
        const statusValue = item.GRPM_GroupStatus === 1 ? 'Active' : 'Inactive';

        const containsActive = /act(ive)?/i.test(firstFilterSearch);
        const containsInactive = /inact(ive)?/i.test(firstFilterSearch);

        const matchesFirstFilter =
            (!firstFilter || !firstFilterSearch) ||
            (firstFilter === 'GRPM_GroupStatus' &&
                (
                    (containsActive && firstFilterValue === 1) ||
                    (containsInactive && firstFilterValue === 2)
                )
            ) ||
            (firstFilter !== 'GRPM_GroupStatus' && String(firstFilterValue).toLowerCase().includes(firstFilterSearch.toLowerCase()));
        const containsActive2 = /act(ive)?/i.test(secondFilterSearch);
        const containsInactive2 = /inact(ive)?/i.test(secondFilterSearch);

        const matchesSecondFilter =
            (!secondFilter || !secondFilterSearch) ||
            (secondFilter === 'GRPM_GroupStatus' &&
                (
                    (containsActive2 && secondFilterValue === 1) ||
                    (containsInactive2 && secondFilterValue === 2)
                )
            ) ||
            (secondFilter !== 'GRPM_GroupStatus' && String(secondFilterValue).toLowerCase().includes(secondFilterSearch.toLowerCase()));
        const matchesStatusFilter = !statusFilter || statusValue === statusFilter;
        return matchesFirstFilter && matchesSecondFilter && matchesStatusFilter;
    });

    const handleCloseSubmenuModal = () => {
        setShowSubmenuModal(false);
        setShowModal(true);
        setSubmenuOptions([]);
    };

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredListData.slice(indexOfFirstItem, indexOfLastItem);

    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const [isSelectOpen, setIsSelectOpen] = useState(false);
    const handleSelectOpen = (selectName) => {
        setIsSelectOpen(selectName);
    };

    const handleSelectClose = () => {
        setIsSelectOpen(null);
    };
    return (
        <>

            <div className='main_container'>
                <h4 className='formHeading'>
                    Group Master<span className='display'></span>
                </h4>
                <div className="filter-container">
                    <div className='select-container_list'>
                        <CustomDropdown
                            options={firstFilterOptions}
                            value={firstFilter}
                            onChange={handleFirstFilterChange}
                            name="firstFilter"
                            placeholder="--Select--"
                            idKey="value"
                            displayKey="label"
                            onMenuOpen={() => handleSelectOpen('firstFilter')}
                            onMenuClose={handleSelectClose}
                        />
                    </div>
                    <input className='search-input' type="text" value={firstFilterSearch} onChange={(e) => setFirstFilterSearch(e.target.value)} placeholder={`Search`} />

                    <div className='select-container_list'>
                        <CustomDropdown
                            options={secondFilterOptions}
                            value={secondFilter}
                            onChange={handleSecondFilterChange}
                            name="secondFilter"
                            placeholder="--Select--"
                            idKey="value"
                            displayKey="label"
                            onMenuOpen={() => handleSelectOpen('secondFilter')}
                            onMenuClose={handleSelectClose}
                        />
                    </div>
                    <input className='search-input' type="text" value={secondFilterSearch} onChange={(e) => setSecondFilterSearch(e.target.value)} placeholder={`Search`} />
                    <div className='select-container_list'>
                        <CustomDropdown
                            options={[
                                { value: 'Active', label: 'Active' },
                                { value: 'Inactive', label: 'Inactive' },
                            ]}
                            value={statusFilter}
                            onChange={handleStatusFilterChange}
                            name="statusFilter"
                            placeholder="--Select Status--"
                            idKey="value"
                            displayKey="label"
                            onMenuOpen={() => handleSelectOpen('statusFilter')}
                            onMenuClose={handleSelectClose}
                        />
                    </div>
                </div>
                <div className="ptable-wrapper">
                    <table className="ptableClass">
                        <thead>
                            <tr>
                                <th>Sr. No.</th>
                                {parseInt(UM_UserType) === 0 && (
                                    <>

                                        <th>Company Name</th>

                                    </>
                                )}
                                <th>Group Name</th>
                                {(parseInt(UM_UserType) === 0 || parseInt(UM_UserType) === 1) &&
                                    <th className="col-group-type">Group Type</th>
                                }
                                <th>Policy Name</th>

                                {shouldShowSCPColumn() && <th>SCP Name</th>}
                                <th>Rights</th>
                                <th className="col-status">Status</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        {filteredListData.length === 0 ? (
                            <tbody >
                                <tr>
                                    <td colSpan="10">No Records Found</td>
                                </tr>
                            </tbody>
                        ) : (
                            <tbody>
                                {currentItems.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                                        {parseInt(UM_UserType) === 0 && (
                                            <>

                                                <td>{item.CM_CompanyName}</td>
                                            </>
                                        )}
                                        <td>{item.GRPM_GroupName}</td>
                                        {(parseInt(UM_UserType) === 0 || parseInt(UM_UserType) === 1) &&
                                            <td className="col-group-type">{item.GroupType}</td>
                                        }
                                        <td>{item.CITPM_PolicyName}</td>

                                        {shouldShowSCPColumn() && <td>{item.SCPM_Name || "-"}</td>}
                                        <td>
                                            <img
                                                src={Icon9}
                                                alt="Pool"
                                                title="Details"
                                                className="pool-button"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => fetchGroupRights(item.GRPM_GroupId)}
                                            />
                                        </td>

                                        <td className="col-status">
                                            {item.GRPM_GroupStatus === 1 ? 'Active' : 'Inactive'}
                                        </td>
                                        <td>
                                            <Link to={`/dashboard/GroupM/${item.GRPM_GroupId}`}>
                                                <img src={Icon3} alt="Edit" title='Edit' />
                                            </Link>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        )}
                    </table>
                </div>
                <ul className="pagination">
                    <li className={currentPage === 1 || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(1)}>First</button>
                    </li>
                    <li className={currentPage === 1 || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(currentPage - 1)}>Previous</button>
                    </li>
                    {Array.from({ length: Math.ceil(filteredListData.length / itemsPerPage) }, (_, index) => (
                        <li key={index} className={currentPage === index + 1 ? "page-item active" : "page-item"}>
                            <button className="page-linkd" onClick={() => paginate(index + 1)}>{index + 1}</button>
                        </li>
                    ))}
                    <li className={currentPage === Math.ceil(filteredListData.length / itemsPerPage) || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(currentPage + 1)}>Next</button>
                    </li>

                    <li className={currentPage === Math.ceil(filteredListData.length / itemsPerPage) || filteredListData.length === 0 ? "page-item disabled" : "page-item"}>
                        <button className="page-linkd" onClick={() => paginate(Math.ceil(filteredListData.length / itemsPerPage))}>Last</button>
                    </li>
                </ul>

                {showModal && (
                    <>
                        {/* 1. Dark backdrop – NO blur here */}
                        <div
                            className="modal-backdrop fade show"
                            style={{
                                position: "fixed",
                                top: 0, left: 0, right: 0, bottom: 0,
                                backgroundColor: "rgba(0, 0, 0, 0.5)",  // darker = better contrast for blur
                                zIndex: 1040,
                            }}
                        />

                        {/* 2. Blur + semi-transparent bg on the MODAL itself */}
                        <div
                            className={`modale fade show`}
                            style={{
                                display: "block",
                                position: "fixed",
                                top: 0, left: 0, right: 0, bottom: 0,
                                zIndex: 1050,
                                paddingRight: "17px",
                                backgroundColor: "rgba(0, 0, 0, 0.3)",        // ← same as your desired
                                backdropFilter: "blur(3px)",                  // ← blur HERE, not on backdrop
                                WebkitBackdropFilter: "blur(3px)",
                            }}
                        >
                            <div
                                className="modal-dialog modal-lg"
                                style={{
                                    maxWidth: "1000px",
                                    marginTop: "-40px"   // 🔥 move upward (adjust value)
                                }}
                            >
                                <div className="modal-content1">
                                    <div className="modal-header">
                                        <h5 className="modal-title">Machine Types and Rights</h5>
                                        <button
                                            type="button"
                                            className="btn-close"
                                            aria-label="Close"
                                            onClick={handleCloseModal}
                                        />
                                    </div>

                                    <div className="modal-body" style={{ paddingTop: "0px" }}>
                                        <table
                                            className="tableClass mt-0"
                                            style={{ width: "100%", tableLayout: "fixed" }}  // ✅ Important
                                        >
                                            <thead>
                                                <tr>
                                                    <th style={{ width: "20%" }}>Sr. No.</th>
                                                    <th style={{ width: "60%" }}>Machine Type</th> {/* ✅ Increased */}
                                                    <th style={{ width: "20%" }}>Machine Rights</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                {Array.from(
                                                    new Map(machineTypes.map(m => [m.gri_AppID, m])).values()
                                                ).map((machine, index) => (
                                                    <tr key={machine.gri_AppID}>
                                                        <td style={{ width: "20%" }}>{index + 1}</td>

                                                        <td
                                                            style={{
                                                                width: "60%",
                                                                wordBreak: "break-word"  // prevents overflow
                                                            }}
                                                        >
                                                            {machine.AppName}
                                                        </td>

                                                        <td style={{ width: "20%", textAlign: "center" }}>
                                                            <img
                                                                src={Icon9}
                                                                alt="Show"
                                                                title="Show Rights"
                                                                className="show-button"
                                                                style={{ cursor: "pointer" }}
                                                                onClick={() => fetchSubmenuOptions(machine.gri_AppID)}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </>
                )}

                {showSubmenuModal && (
                    <>
                        <div className="popup_overlay"
                            style={{
                                backdropFilter: "blur(4px)",
                                backgroundColor: "rgba(0,0,0,0.3)"
                            }}>
                            <div className="popup" style={{ height: '645px' }}>
                                {/* <div className="modal-header"> */}
                                <div>
                                    <Link onClick={handleCloseSubmenuModal}>
                                        <Image src={x} alt="x" className="x" /></Link>
                                </div>
                                <h5 className="modal-title">
                                    Machine : {selectedMachineName ? `${selectedMachineName}` : ""}
                                </h5>
                                {/* <button
                                    type="button"
                                    className="btn-close"
                                    aria-label="Close"
                                    onClick={handleCloseSubmenuModal}
                                /> */}
                                {/* </div> */}
                                {/* <div
                                    className="modal-body"
                                    style={{
                                        paddingTop: "0px",
                                        // maxHeight: "200px",
                                        overflowY: "auto"
                                    }}
                                > */}
                                <table className="tableClass">
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>Rights</th>
                                        </tr>
                                    </thead>
                                    <tbody style={{
                                        display: 'block',
                                        maxHeight: '220px',
                                        overflowY: 'auto'
                                    }}>
                                        {submenuOptions.map((right, index) => (
                                            <tr key={right.STM_ID}>
                                                <td>{index + 1}</td>
                                                <td>{right.STM_RoleName}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                {/* </div> */}
                            </div>
                        </div>

                    </>
                )}


            </div>
            <Link to={`/dashboard/GroupM`}>
                <button type="button" className="back_btn">BACK</button>
            </Link>
        </>
    );

}

export default GMList;

